// 不同环境加载不同的 i18n 的 host

// 环境变量
export const host = {
  local: "local", // 本地
  development: "development", // dev
  stage: "stage", // stage
  test: "test", // test
  test2: "test", // test2
  production: "production", // prod
};

// 环境判断
export const langHostEnv = {
  isLocal: process.env.ENV_NAME === host.local,
  isDev: process.env.ENV_NAME === host.development,
  isTest: process.env.ENV_NAME === host.test,
  isTest2: process.env.ENV_NAME === host.test2,
  isProd: process.env.ENV_NAME === host.production,
  isStage: process.env.ENV_NAME === host.stage,
};

// // 不同环境加载不同的 i18n 的 语言包路径
// export const localsPath: LocalsPathType = {
//   // local: `/locales`, // 本地
//   local: `//glsp-img.unipus.cn/i18n`, // 本地
//   test: '//glsp-img.unipus.cn/i18n', // test
//   test2: '//glsp-img.unipus.cn/i18n', // test2
//   development: `//glsp-img.unipus.cn/i18n`, // dev
//   stage: `//glsp-img.unipus.cn/i18n`, // test
//   production: `//glsp-img.unipus.cn/i18n-prd`, // prd
// }

// 生产手动修改更新语言包 version
export const version = "1.0";
